const t = (r) => {
  if (typeof r == "number")
    return "number";
  if (typeof r == "string")
    return "string";
  if (r instanceof Date)
    return "date";
};
export {
  t as getFormatFromValue
};
